var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "product-property-list"
  }, [_vm.title ? _c('h2', {
    staticClass: "product-property-list__title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-property-list__group"
  }, _vm._l(_vm.properties, function (item, index) {
    return _c('dl', {
      key: index,
      staticClass: "product-property-list__row"
    }, [_c('dt', {
      staticClass: "product-property-list__prop"
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]), _vm._v(" "), _c('dd', {
      staticClass: "product-property-list__value"
    }, [_vm._v("\n        " + _vm._s(item.value) + "\n      ")])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }